export default "__VITE_ASSET__Dodo6C5U__"